import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useSnackbar} from 'notistack';
import {
  DialogTitle,
  DialogActions,
  Dialog,
  Grid,
  FormControlLabel,
  DialogContent,
  Checkbox,
  FormControl,
  IconButton,
  Divider
} from '@mui/material';

import {APP} from 'src/styles/variables';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import IsBhFilter from '@modules/home/main/sub-modules-menu/sub-module-page-section/IsBhFilter';
import {createAuditLog} from '@shared/services/service-handlers/PrivateService';
import AuthUtils from 'src/utils/AuthUtils';

import CancelIcon from '@mui/icons-material/Cancel';
import LabelInput from '@components/label/LabelInput';
import {LoadingButton} from '@mui/lab';
import FormConstants from '@shared/constants/FormConstants';
import {
  BASE_DEMOGRAPHIC_ID,
  BASE_LEGACY_APP,
  BASE_MENU_ITEM,
  BASE_PROCEDURE_ID,
  BASE_RECORD_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  BASE_ROUTE_SUB_MODULE,
  BASE_UNIQUE_ID,
  CHILD_TAB_NAME,
  INVOICE_NUMBER,
  IS_FROM_EPIC,
  IS_FROM_ATHENA,
  MODE,
  PARAMS_KEY
} from 'src/routes/BaseRoute';
import {useNavigate} from 'react-router-dom';
import {useModuleContext} from '@context/ModuleContext';
import {useAppContext} from '@context/AppContext';
import EncryptUtils from 'src/utils/EncryptUtils';

const IsBHDialog = (props: any): React.ReactElement => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {enqueueSnackbar} = useSnackbar();
  const {...other} = props;
  const {isBhvaluesearch, isBhdata, submodule} = props;
  const getAdditionalLocaleStorageData =
    AuthUtils.getSelectedAdditionalCheckBoxData();
  const [loaders, setLoaders] = React.useState<boolean>(false);
  const [showDialog, setShowDialog] = React.useState(
    props?.showDialog || false
  );
  const [isBHReason, setIsBHReason] = React.useState('');
  const [selectedValue, setSelectedValue] =
    React.useState('Without_Restricted');

  const {
    appState: {applicationName}
  } = useAppContext();
  const {setIsBHReasonData} = useModuleContext();
  const recordId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );

  const legacy_app = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_LEGACY_APP
  );

  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_ID
  );
  const invoice_number = EncryptUtils.getDecryptedData(
    location?.search,
    INVOICE_NUMBER
  );
  const isFromEpic = EncryptUtils.getDecryptedData(
    location?.search,
    IS_FROM_EPIC
  );
  const isFromAthena = EncryptUtils.getDecryptedData(
    location?.search,
    IS_FROM_ATHENA
  );
  const demoId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_DEMOGRAPHIC_ID
  );
  const procedureid = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_PROCEDURE_ID
  );
  const mode = EncryptUtils.getDecryptedData(location?.search, MODE);
  const menuItem = new URLSearchParams(location?.search).get(BASE_MENU_ITEM);

  useEffect(() => {
    if (!props?.disableIsBHSave) {
      setIsBHReasonData(isBHReason);
    }
  }, [isBHReason]);

  const handleChange = (event: any) => {
    setSelectedValue(event.target.value);
  };
  const handlenavigateToPA = () => {
    // console.log('params', params, items);
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_DEMOGRAPHIC_ID]: demoId,
      [BASE_PROCEDURE_ID]: procedureid,
      [BASE_RECORD_ID]: recordId,
      [BASE_LEGACY_APP]: props?.legacyApp || legacy_app,
      [BASE_UNIQUE_ID]: uniqueId,
      [IS_FROM_EPIC]: isFromEpic,
      [IS_FROM_ATHENA]: isFromAthena,
      [MODE]: mode,
      [INVOICE_NUMBER]: invoice_number,
      [CHILD_TAB_NAME]: 'Encounters'
    });
    let url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/patient-accounting/${BASE_ROUTE_SUB_MODULE}/accounts?${PARAMS_KEY}=${paramsKey}`;
    if (menuItem) {
      url += `&${BASE_MENU_ITEM}=${menuItem}`;
    }
    AuthUtils.clearSelectedCheckBoxData();
    AuthUtils.clearSelectedCheckBoxList();
    localStorage.setItem('patient_encounterData_removed', 'true');
    navigate(url);
  };
  const handleClose = (event?: any, reason?: any) => {
    if (reason !== 'backdropClick') {
      setShowDialog(false);
      props?.setShowDialog(false);
      if (submodule != 'reports') {
        if (props?.triggerFunction) {
          props.triggerFunction(null);
        }
      }
    }
  };

  const handleCloseisbhsearch = (event?: any, reason?: any) => {
    if (reason !== 'backdropClick') {
      setShowDialog(false);
      props?.setShowDialog(false);
      if (props?.triggerFunction) {
        props.triggerFunction('dontshow');
      }
    }
  };

  const makeAuditLog = async (value: string | boolean, token?: any) => {
    try {
      if (props.submodule != 'reports') {
        localStorage.setItem('check_isbh', value.toString());
      }
      const data = {
        application_name: applicationName,
        isBH_selected: value == 'Without_Restricted',
        // !isBHReason?.length && value == false ? undefined : !value,
        isBH_reason:
          value == 'Without_Restricted' ? 'Hide Restricted Data' : value,
        event_description: `User added ISBH reason : ${value}`,
        audit_identifier: AuthUtils.getAuditIdentifier(),
        audit_identifier_type: AuthUtils.getAuditIdentifierType(),
        audit_legacy_app: AuthUtils.getAuditLegacyApp()
      };
      await createAuditLog(props.module, data, token);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };

  const makeAuditLogisbh = async (
    value: string | boolean,
    checkedisbhdata?: any,
    token?: any
  ) => {
    try {
      const jsonString = JSON.stringify(checkedisbhdata);
      // Concatenate the string with the JSON
      const checkisbhString = `${value} ${jsonString}`;
      const data = {
        application_name: applicationName,
        isBH_selected: value == 'Without_Restricted',
        // !isBHReason?.length && value == false ? undefined : value,
        isBH_reason:
          value == 'Without_Restricted' ? 'Hide Restricted Data' : value,
        event_description: `User added ISBH reason : ${checkisbhString}`,
        audit_identifier: AuthUtils.getAuditIdentifier(),
        audit_identifier_type: AuthUtils.getAuditIdentifierType(),
        audit_legacy_app: AuthUtils.getAuditLegacyApp()
      };
      await createAuditLog(props.module, data, token);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };

  const handleSubmit = async () => {
    try {
      if (props?.triggerFunction) {
        if (selectedValue == 'Without_Restricted') {
          makeAuditLog('Without_Restricted');
        } else if (selectedValue == 'View_Restricted' && isBHReason) {
          makeAuditLog(isBHReason);
        }
        props.triggerFunction(selectedValue, isBHReason);
        setShowDialog(false);
        props?.setShowDialog(false);
      }
    } catch (error) {
      setLoaders(false);
      const errMessage = getErrorMessage(error);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };

  const handleSubmitisbhsearch = async () => {
    try {
      if (isBHReason) {
        makeAuditLogisbh(isBHReason, isBhdata);
      }
      props.triggerFunction(isBHReason);
      setShowDialog(false);
      props?.setShowDialog(false);
    } catch (error) {
      setLoaders(false);
      const errMessage = getErrorMessage(error);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };

  if (isBhvaluesearch) {
    return (
      <Dialog
        open={showDialog}
        onClose={handleCloseisbhsearch}
        sx={{
          backdropFilter: 'blur(5px)',
          '& .MuiDialog-paper': {
            maxHeight: 435,
            borderRadius: '10px',
            overflowY: 'unset'
          }
        }}
        maxWidth="sm"
        {...other}>
        <DialogTitle
          sx={{
            fontWeight: '700',
            color: APP.PALETTE.TEXT.PRIMARY,
            fontSize: '1.2rem !important'
          }}>
          {t('PRIVATE.IS_BH.VIEW_RESTRICTED_DATA', {ns: 'private'})}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseisbhsearch}
          sx={{
            position: 'absolute',
            left: '94%',
            top: '-4%',
            color: theme => theme.palette.grey[500]
          }}>
          <CancelIcon
            sx={{color: APP.PALETTE.PRIMARY.MAIN, fontSize: '2.3rem'}}
          />
        </IconButton>
        <Divider />
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            paddingX: '6rem'
          }}>
          <LabelInput
            label={t('PRIVATE.IS_BH.DIALOG_TITLE', {ns: 'private'}) + ':'}
            style={{
              fontSize: '1.02rem !important',
              fontWeight: '500',
              paddingBottom: '1rem'
            }}
            align={'left'}
            variant={'subtitle1'}
            labelColor={APP.PALETTE.INFO.MAIN}
          />
          <FormControl component="fieldset" sx={{textAlign: 'center'}}>
            <Grid container sx={{flexDirection: 'column', paddingTop: '1rem'}}>
              <Grid item>
                <LabelInput
                  label={t('PRIVATE.IS_BH.SHOW_RESTRICTED_DATA_SUBTITLE', {
                    ns: 'private'
                  })}
                  style={{fontStyle: 'italic'}}
                  align={'left'}
                  variant={'caption'}
                  labelColor={APP.PALETTE.GREY.SHADE_600}
                />
                <IsBhFilter
                  module={'clinical'}
                  optionValue={isBHReason}
                  setOptionValue={setIsBHReason}
                  disabled={false}
                  autoCompleteProps={{size: 'small', sx: {marginTop: 1}}}
                />
              </Grid>
            </Grid>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{justifyContent: 'center', paddingBottom: '1.2rem'}}>
          <LoadingButton
            type="submit"
            variant="contained"
            loading={loaders}
            sx={{
              fontWeight: 'normal',
              backgroundColor: `${APP.PALETTE.PRIMARY.MAIN}`,
              '&:hover': {
                backgroundColor: `${APP.PALETTE.PRIMARY.DARK}`
              }
            }}
            disabled={loaders || !isBHReason}
            onClick={handleSubmitisbhsearch}>
            {t('PRIVATE.COMMON.PROCEED', {ns: 'private'})}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Dialog
      open={showDialog}
      onClose={handleClose}
      sx={{
        backdropFilter: 'blur(5px)',
        '& .MuiDialog-paper': {
          maxHeight: 435,
          borderRadius: '10px',
          overflowY: 'unset'
        }
      }}
      maxWidth="sm"
      {...other}>
      <DialogTitle
        sx={{
          fontWeight: '700',
          color: APP.PALETTE.TEXT.PRIMARY,
          fontSize: '1.2rem !important'
        }}>
        {t('PRIVATE.IS_BH.VIEW_RESTRICTED_DATA', {ns: 'private'})}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={e => {
          if (props.submodule === 'reports') {
          } else if (props.module === FormConstants.MODULE.PATIENT_ACCOUNTING) {
            navigate(
              `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.PATIENT_ACCOUNTING}`
            );
          } else {
            if (getAdditionalLocaleStorageData) {
              handlenavigateToPA();
            } else {
              navigate(
                `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.CLINICAL}`
              );
            }
          }
          handleClose();
        }}
        sx={{
          position: 'absolute',
          left: '94%',
          top: '-4%',
          color: theme => theme.palette.grey[500]
        }}>
        <CancelIcon
          sx={{color: APP.PALETTE.PRIMARY.MAIN, fontSize: '2.3rem'}}
        />
      </IconButton>
      <Divider />
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          paddingX: '6rem'
        }}>
        <LabelInput
          label={t('PRIVATE.IS_BH.DIALOG_TITLE', {ns: 'private'}) + ':'}
          style={{
            fontSize: '1.02rem !important',
            fontWeight: '500',
            paddingBottom: '1rem'
          }}
          align={'left'}
          variant={'subtitle1'}
          labelColor={APP.PALETTE.INFO.MAIN}
        />
        <FormControl component="fieldset" sx={{textAlign: 'center'}}>
          {props.submodule != 'reports' && (
            <>
              <FormControlLabel
                style={{whiteSpace: 'nowrap'}}
                value="Without_Restricted"
                control={
                  <Checkbox
                    onChange={handleChange}
                    checked={selectedValue === 'Without_Restricted'}
                  />
                }
                label={t('PRIVATE.IS_BH.WITHOUT_RESTRICTED_DATA', {
                  ns: 'private'
                })}
              />
              <LabelInput
                label={t('PRIVATE.IS_BH.WITHOUT_RESTRICTED_DATA_SUBTITLE', {
                  ns: 'private'
                })}
                style={{fontStyle: 'italic'}}
                align={'left'}
                variant={'caption'}
                labelColor={APP.PALETTE.GREY.SHADE_600}
              />
            </>
          )}
          <Grid container sx={{flexDirection: 'column', paddingTop: '1rem'}}>
            <Grid item xs={6}>
              <FormControlLabel
                style={{whiteSpace: 'nowrap'}}
                value="View_Restricted"
                control={
                  <Checkbox
                    onChange={handleChange}
                    checked={selectedValue === 'View_Restricted'}
                  />
                }
                label={t('PRIVATE.IS_BH.SHOW_RESTRICTED_DATA', {
                  ns: 'private'
                })}
              />
            </Grid>
            <Grid item>
              <LabelInput
                label={t('PRIVATE.IS_BH.SHOW_RESTRICTED_DATA_SUBTITLE', {
                  ns: 'private'
                })}
                style={{fontStyle: 'italic'}}
                align={'left'}
                variant={'caption'}
                labelColor={APP.PALETTE.GREY.SHADE_600}
              />
              <IsBhFilter
                module={props?.module}
                optionValue={isBHReason}
                setOptionValue={setIsBHReason}
                disabled={selectedValue !== 'View_Restricted'}
                autoCompleteProps={{size: 'small', sx: {marginTop: 1}}}
              />
            </Grid>
          </Grid>
        </FormControl>
      </DialogContent>
      <DialogActions sx={{justifyContent: 'center', paddingBottom: '1.2rem'}}>
        <LoadingButton
          type="submit"
          variant="contained"
          loading={loaders}
          sx={{
            fontWeight: 'normal',
            backgroundColor: `${APP.PALETTE.PRIMARY.MAIN}`,
            '&:hover': {
              backgroundColor: `${APP.PALETTE.PRIMARY.DARK}`
            }
          }}
          disabled={
            loaders ||
            selectedValue.length <= 0 ||
            (selectedValue == 'View_Restricted' && !isBHReason)
          }
          onClick={handleSubmit}>
          {t('PRIVATE.COMMON.PROCEED', {ns: 'private'})}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default IsBHDialog;
